import classNames from "classnames";
import { Flex } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { CustomValueTag } from "PFCore/types";

import { CustomValuePillProps } from "../custom_value_pill";
import css from "./grouped_icon.module.scss";

type TagsGroupedIconProps = {
  tags?: CustomValueTag[];
} & Pick<CustomValuePillProps, "theme">;

export const TagsGroupedIcon = ({ tags, theme }: TagsGroupedIconProps) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  if (tags.length === 1) {
    return (
      <Icon name={tags[0].iconName} color={theme === "dark" ? "paletteWhite0" : "paletteBlue0"} size="sm" />
    );
  }

  return (
    <Flex center className={classNames(css.groupedIconBackground, { [css.dark]: theme === "dark" })}>
      <Icon name="tag" color="paletteWhite0" size="xxs" />
    </Flex>
  );
};
